// extracted by mini-css-extract-plugin
export default {"InputNumber":"InputNumber_InputNumber__yY3Cs"};